import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip'
import styled from 'styled-components'

interface Props {
  title: string | JSX.Element
  position?: 'top' | 'bottom' | 'left' | 'right'
  enterDelay?: number
  children: JSX.Element
}

export default function CustomTooltip({ title, position = 'top', enterDelay = 100, children }: Props): JSX.Element {
  return (
    <StyledTooltip
      enterDelay={enterDelay}
      disableInteractive={true}
      title={<TooltipContent>{title}</TooltipContent>}
      arrow
      placement={position}
    >
      <TooltipTrigger>{children}</TooltipTrigger>
    </StyledTooltip>
  )
}

const StyledTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(() => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: '#222a35',
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#222a35',
  },
}))

const TooltipContent = styled.div`
  color: #fff;
  padding: 10px;
  font-size: 12px;
  & div {
    margin: 5px 0;
  }
`

const TooltipTrigger = styled.span`
  display: inline-flex;
`
